'use strict';

import {Helper} from "../helpers/Helper.js";

export class AdminActions {
	#resetLevitVersionButton;
	#flushRedisButton;
	constructor() {
		this.admin_ajax = admin_ajax[ 0 ];

		this.#resetLevitVersionButton = document.querySelector('.reset-version-button');
		if (this.#resetLevitVersionButton) {
			this.resetVersion();
		}

		this.#flushRedisButton = document.querySelector('.flush-redis-button');
		if (this.#flushRedisButton) {
			this.flushRedisCache();
		}
	}

	flushRedisCache() {
		this.#flushRedisButton.addEventListener('click', async (event) => {
			document.body.classList.add('ajax-loading');

			await Helper.request(
				this.admin_ajax,
				{
					action: 'send_request_flush_redis'
				},
			)
				.then(response => {
					if (response.success) {
						window.location.reload();
					} else {
						document.body.classList.remove('ajax-loading');
					}
				})
				.catch(response => {
					console.error(response)
					document.body.classList.remove('ajax-loading');
				})

		});
	}
	resetVersion(){
		this.#resetLevitVersionButton.addEventListener('click', async (event) => {
			const iconElement = this.#resetLevitVersionButton.querySelector('.ab-icon');
			iconElement.classList.add('icon-rotate');

			await Helper.request(
				this.admin_ajax,
				{
					action: 'send_request_reset_levit_version'
				},
			)
				.then(response => {
					if (response.success) {
						window.location.reload();
					}
				})
				.catch(response => {
					console.error(response)
				})

		});
	}
}
